import React,{forwardRef} from "react";
import {normalizeUppercaseText} from "./text-normalization";

function normalizeInput(element:HTMLInputElement|HTMLTextAreaElement){
  const start=element.selectionStart,end=element.selectionEnd;
  const before=element.value,next=normalizeUppercaseText(before);
  if(next===before)return;
  element.value=next;
  if(start!=null&&end!=null){
    const delta=next.length-before.length;
    queueMicrotask(()=>element.setSelectionRange(Math.max(0,start+delta),Math.max(0,end+delta)));
  }
}
export const UppercaseInput=forwardRef<HTMLInputElement,React.InputHTMLAttributes<HTMLInputElement>>(function UppercaseInput(props,ref){
  return <input {...props} ref={ref} autoCapitalize="characters" onInput={event=>{normalizeInput(event.currentTarget);props.onInput?.(event)}}/>;
});
export const UppercaseTextarea=forwardRef<HTMLTextAreaElement,React.TextareaHTMLAttributes<HTMLTextAreaElement>>(function UppercaseTextarea(props,ref){
  return <textarea {...props} ref={ref} autoCapitalize="characters" onInput={event=>{normalizeInput(event.currentTarget);props.onInput?.(event)}}/>;
});
